export enum FormFieldTypeConstants {
  File = 'file',
  Text = 'text',
  Radio = 'radio',
  Number = 'number',
  Select = 'select',
  Checkbox = 'checkbox',
  CheckboxGroup = 'checkboxGroup',
  Textarea = 'textarea',
  RichText = 'rich-text',
  Datepicker = 'datepicker',
};

export enum FormErrors {
  Required = 'This is a required field.',
  AudienceRequired = 'Please select the audience.',
  SupportedExcelFormats = 'Supported file formats are .xlsx and .csv.',
  EmailList = 'Invalid list of emails.',
  MaxSubmissionCount = 'The minimum submission count cannot be greater than the selected users in the audience.',
  MaxSelectedAudienceUsers = 'The number of users cannot be greater than the minimum submission count.',
  MinValue0 = 'The minimum value cannot be less than 0.',
  QuestionsRequired = 'Please add at least one question.',
  FeedbackLoopFeedbackTypeRequired = 'Please set the feedback-type of the feedback loop.',
  FeedbackLoopAudienceRequired = 'Please set the audience of the feedback loop.',
  FeedbackLoopFeedbackForRequired = 'Please set the feedback-for pairs of the feedback loop.',
  FeedbackLoopNotificationPreferenceRequired = 'Please set the send-notification-as for the feedback loop.',
  GroupAdminsFromMembers = 'Only group members can be admins.',
  MinDateToday = 'The date-time should not be in past.',
  MinEndDate = 'The end date-time should not be before start date-time.'
}

export enum FileFormats {
  CSV = 'text/csv',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS = 'application/vnd.ms-excel',
  PDF = 'application/pdf',
}